import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {BalancesListHeader} from './components/header/BalancesListHeader'
import {BalancesTable} from './table/BalancesTable'
import { BalanceEditModal } from './Balance-edit-modal/BalanceEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const BalancesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <BalancesListHeader />
        <BalancesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <BalanceEditModal />}
    </>
  )
}

const BalancesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <BalancesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {BalancesListWrapper}
